import './scss/pages/checkout.scss'
import CartShipping from './js/CartShipping'

new CartShipping()
